<template>
  <div class="card">
    <div class="card-body p-0">
      <cardHead
        :title="'Hotel Names'"
        :buttons="[
          {
            title: 'Reflesh',
            icon: 'fas fa-redo-alt',
            emit: 'get',
          },
        ]"
        @get="get"
      ></cardHead>
      <load-area v-if="data == null"></load-area>
      <dataTable
        :name="'KolayrezMatchProviderHotelNames'"
        ref="agGrid"
        :columnDefs="columnDefs"
        :data="data"
        @cellClicked="matchShow = $event.data"
        :addContextMenuItem="getContextMenuItems"
        v-if="data != null"
        :rowClassRules="{
          // row style function
          success: (params) => {
            // var numSickDays = params.data;
            return params?.data?.HotelId != null;
          },
          warning: (params) => {
            // var numSickDays = params.data;
            return params?.data?.NoMatch;
          },
        }"
      ></dataTable>
      <match
        v-if="matchShow != null"
        :setModel="matchShow"
        :operators="data"
        @match="getRow"
        @close="matchShow = null"
      ></match>
    </div>
  </div>
</template>

<script>
import match from "./match";
export default {
  name: "HotelNames",
  components: { match },
  data() {
    return {
      columnDefs: [
        // {
        //   headerName: "Id",
        //   width: 80,
        //   filter: "agNumberColumnFilter",
        //   field: "Id",
        //   sortable: true,
        //   cellClick: true,
        //   enableRowGroup: true,
        // },
        // {
        //   headerName: "ProviderId",
        //   width: 140,
        //   filter: "agNumberColumnFilter",
        //   field: "ProviderId",
        //   sortable: true,
        //   cellClick: true,
        //   enableRowGroup: true,
        // },
        // {
        //   headerName: "HotelId",
        //   width: 140,
        //   filter: "agNumberColumnFilter",
        //   field: "HotelId",
        //   sortable: true,
        //   cellClick: true,
        //   enableRowGroup: true,
        // },
        {
          headerName: "Name",
          filter: "agTextColumnFilter",
          field: "ProviderName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Provider Hotel Name",
          filter: "agTextColumnFilter",
          field: "ProviderHotelName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
        {
          headerName: "Hotel Name",
          filter: "agTextColumnFilter",
          field: "HotelName",
          flex: 1,
          minWidth: 140,
          sortable: true,
          cellClick: true,
          enableRowGroup: true,
        },
      ],
      data: null,
      matchShow: null,
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      this.$appAxiosAdmin
        .get(`kolayrez/ProviderHotelNames`)
        .then((response) => {
          this.data = response.data.sort((x, y) => {
            return y.Id - x.Id;
          });
        });
    },
    getRow(item) {
      console.log(item);
      this.$refs.agGrid.changeRow("Id", item);
    },
    getContextMenuItems(params) {
      let result = [
        "copy",
        "export",
        {
          name: "Match Hotel",
          icon: "<i class='fas fa-exchange-alt'></i>",
          action: () => {
            this.matchShow = params.node.data;
          },
        },
        {
          name: params.node.data.NoMatch ? "Yes Match Hotel" : "No Match Hotel",
          icon: !params.node.data.NoMatch
            ? "<i class='fas fa-ban'></i>"
            : '<i class="far fa-check-circle"></i>',
          action: () => {
            this.$appAxiosAdmin
              .post(`kolayrez/ProviderHotelNames/UpdateNoMatch`, {
                Id: params.node.data.Id,
                NoMatch: !params.node.data.NoMatch,
              })
              .then(() => {
                this.$refs.agGrid.changeRow("Id", {
                  ...params.node.data,
                  NoMatch: !params.node.data.NoMatch,
                });
              });
          },
        },
      ];
      return result;
    },
  },
  computed: {},
};
</script>
